import React from 'react';
import Icon from 'components/Icon';
import { Img } from 'components/Material';
import { Popover } from 'antd';
import $$ from 'cmn-utils';
import { textEllipsis, getMaxWidthHeight } from '@/utils/common';

export const columnsPicture = (self, showKeys, parentOrgIds, isShare, buttonAuth) => {
  return [
    {
      title: window.language['material.columns.filename'],
      name: 'name',
      dataIndex: 'name',
      tableItem: {
        width: 240,
        render(text, record) {
          let divWH = getMaxWidthHeight(record.sense);
          let scope = record.scope;
          let returnNode = null;
          let showImgContent = (
            <div style={{ width: divWH.width + 'px', height: divWH.height + 'px' }}>
              <Img src={record.preview} style={{ width: divWH.width + 'px', height: divWH.height + 'px' }}/>
            </div>
          );
          let folderIcon = null;
          if (scope) {
            folderIcon = <Icon className="material-folder-o" />;
          }else{
            text = `${text}.${record.suffix}`;
          }
          
          let nameContent = (<div className="material-column"
            onClick={(e) => {
              self.onCheckedMaterialData(record);
              self.onDoubleClickData(e, record);
            }}
          >
            {folderIcon}
            {textEllipsis(text, 22)}
          </div>);
          if (scope) {
            return nameContent;
          }else {
            return (<Popover placement="right" content={showImgContent} title={text}>
              {nameContent}
            </Popover>)
          }
        }
      },
      formItem: {}
    },
    {
      title: window.language['material.columns.size'],
      name: 'size',
      dataIndex: 'size',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['material.columns.sense'],
      name: 'sense',
      dataIndex: 'sense',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['material.columns.org'],
      name: 'org.name',
      dataIndex: 'org.name',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['material.columns.creator'],
      name: 'creator.username',
      dataIndex: 'creator.username',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['material.columns.updateTime'],
      name: 'updateTime',
      dataIndex: 'updateTime',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['common.operate'],
      name: 'oper',
      dataIndex: 'oper',
      tableItem: {
        width: '23%',
        render(text, record) {
          let resultNode = null;
          let isShareStatus = record.is_share;
          const authCodes = $$.getStore('authCodes');//按钮权限代码列表
          if (!authCodes) return null;
          let shareParam = { tipMsg: '', iconMsg: '' };
          if (isShareStatus === '0') {
            shareParam.tipMsg = window.language['material.share'];
            shareParam.iconMsg = 'share-o';
          } else {
            shareParam.tipMsg = window.language['material.cancelShare'];
            shareParam.iconMsg = 'share-no-o';
          }
          let shareNode = null;
          let downNode = null;
          if (authCodes[buttonAuth[6]]) {
            shareNode = <li title={shareParam.tipMsg} onClick={(e) => { self.onShareFile(e, isShareStatus, record) }}><Icon className={shareParam.iconMsg} /></li>
          }
          if (authCodes[buttonAuth[9]]) {
            downNode = <li title={window.language['common.download']} onClick={(e) => { self.onDownloadMaterial(e, record) }}><Icon className="material-download-list" /></li>
          }
          if (isShare === '1') { // 我的分享/共享素材
            let operShare = shareNode;
            if (parentOrgIds && parentOrgIds.length > 0) {
              let arr = parentOrgIds.split(",");
              let index = arr.indexOf(record.org.id);
              if (index !== -1) {
                operShare = null;
              }
            }
            resultNode = (
              <ul className='material-listoper-default'>
                <li title={window.language['material.preview']} onClick={(e) => { self.onShowPreviewHandler(e, record) }}><Icon className="preview-o" /></li>
                {downNode}
                {operShare}
              </ul>
            );
          } else { // 不分享
            let flag = false;  // 是否展开收缩
            let scope = record.scope;
            for (let key of showKeys) {
              if (key === record.id) {
                flag = true;
                break;
              }
            }
            if (!scope) { // 素材
              let updNode = null;
              let delNode = null;
              if (authCodes[buttonAuth[1]]) {
                updNode = <li title={window.language['common.update']} onClick={(e) => { self.onShowRename(e, record) }}><Icon className="edit-o ahover aactive" /></li>
              }
              if (authCodes[buttonAuth[2]]) {
                delNode = <li title={window.language['common.del']} onClick={(e) => { self.onDeleteFile(e, record) }}><Icon className="delete-o ahover aactive" /></li>
              }
              resultNode = (
                <div>
                  {flag ? (
                    <ul className='material-listoper-default'>
                      {updNode}
                      {delNode}
                      {shareNode}
                      <li title={window.language['material.preview']} onClick={(e) => { self.onShowPreviewHandler(e, record) }}><Icon className="preview-o" /></li>
                      {downNode}
                      <li onClick={(e) => { self.onListToolAction(e, record.id, false) }}><Icon className='left-arrow-o' /></li>
                    </ul>
                  ) : (
                      <ul className='material-listoper-default'>
                        {updNode}
                        {delNode}
                        {shareNode}
                        <li onClick={(e) => { self.onListToolAction(e, record.id, true) }}><Icon className='right-arrow-o' /><span className="more">{window.language['common.more']}</span></li>
                      </ul>
                    )}
                </div>
              );
            } else {  // 文件夹
              let editNode = null;
              let delNode = null;
              if (authCodes[buttonAuth[5]]) {
                editNode = <li title={window.language['material.folder.editFolder']} onClick={(e) => { self.onShowAddFolder(e, '1', record) }}><Icon className="edit-o" /></li>
              }
              if (authCodes[buttonAuth[3]]) {
                delNode = <li title={window.language['common.del']} onClick={(e) => { self.onDeleteFile(e, record) }}><Icon className="delete-o" /></li>
              }
              resultNode = (
                <ul className='material-listoper-default'>
                  {editNode}
                  {delNode}
                </ul>
              );
            }
          }
          return (
            <div>
              {resultNode}
            </div>
          )
        }
      },
      formItem: {},
    }
  ]
};

export const columnsVideo = (self, showKeys, parentOrgIds, isShare, buttonAuth) => {
  return [
    {
      title: window.language['material.columns.filename'],
      name: 'name',
      dataIndex: 'name',
      tableItem: {
        width: 240,
        render(text, record) {
          let divWH = getMaxWidthHeight(record.sense);
          let scope = record.scope;
          let returnNode = null;
          let showImgContent = (
            <div style={{ width: divWH.width + 'px', height: divWH.height + 'px' }}>
              <Img src={record.preview} style={{ width: divWH.width + 'px', height: divWH.height + 'px' }} />
            </div>
          );
          let folderIcon = null;
          if (scope) {
            folderIcon = <Icon className="material-folder-o" />;
          }else{
            text = `${text}.${record.suffix}`;
          }
          
          let nameContent = (<div className="material-column"
            onClick={(e) => {
              self.onCheckedMaterialData(record);
              self.onDoubleClickData(e, record);
            }}
          >
            {folderIcon}
            {textEllipsis(text, 22)}
          </div>);
          if (scope) {
            return nameContent;
          }else {
            return (<Popover placement="right" content={showImgContent} title={text}>
              {nameContent}
            </Popover>)
          }
        }
      },
      formItem: {}
    },
    {
      title: window.language['material.columns.size'],
      name: 'size',
      dataIndex: 'size',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['video.columns.status'],
      name: 'status',
      dataIndex: 'status',
      dict: [{
        code: "1",
        codeName: window.language['video.status.normal']
      },
      {
        code: "0",
        codeName: window.language['video.status.processing']
      },
      {
        code: "2",
        codeName: window.language['video.status.processFailed']
      }],
      tableItem: {
        render(text, record, index) {
          let status = "";
          if (text === '1') {
            status = window.language['video.status.normal'];
          } else if (text === '0' || text === '3' || text === '4') {
            status = window.language['video.status.processing'];
          } else if (text === '2' || text === '5') {
            status = window.language['video.status.processFailed'];
          }
          return (
            <span>{status}</span>
          )
        }
      },
    },
    {
      title: window.language['video.columns.time'],
      name: 'video_time',
      dataIndex: 'video_time',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['material.columns.sense'],
      name: 'sense',
      dataIndex: 'sense',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['material.columns.org'],
      name: 'org.name',
      dataIndex: 'org.name',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['material.columns.creator'],
      name: 'creator.username',
      dataIndex: 'creator.username',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['material.columns.updateTime'],
      name: 'updateTime',
      dataIndex: 'updateTime',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['common.operate'],
      name: 'oper',
      dataIndex: 'oper',
      tableItem: {
        width: '23%',
        render(text, record) {
          let resultNode = null;
          let isShareStatus = record.is_share;
          const authCodes = $$.getStore('authCodes');//按钮权限代码列表
          if (!authCodes) return null;
          let shareParam = { tipMsg: '', iconMsg: '' };
          if (isShareStatus === '0') {
            shareParam.tipMsg = window.language['material.share'];
            shareParam.iconMsg = 'share-o';
          } else {
            shareParam.tipMsg = window.language['material.cancelShare'];
            shareParam.iconMsg = 'share-no-o';
          }
          let shareNode = null;
          let downNode = null;
          if (authCodes[buttonAuth[6]]) {
            shareNode = <li title={shareParam.tipMsg} onClick={(e) => { self.onShareFile(e, isShareStatus, record) }}><Icon className={shareParam.iconMsg} /></li>
          }
          if (authCodes[buttonAuth[9]]) {
            downNode = <li title={window.language['common.download']} onClick={(e) => { self.onDownloadMaterial(e, record) }}><Icon className="material-download-list" /></li>
          }
          if (isShare === '1') { // 我的分享/共享素材
            let operShare = shareNode;
            if (parentOrgIds && parentOrgIds.length > 0) {
              let arr = parentOrgIds.split(",");
              let index = arr.indexOf(record.org.id);
              if (index !== -1) {
                operShare = null;
              }
            }
            resultNode = (
              <ul className='material-listoper-default'>
                <li title={window.language['material.preview']} onClick={(e) => { self.onShowPreviewHandler(e, record) }}><Icon className="preview-o" /></li>
                {downNode}
                {operShare}
              </ul>
            );
          } else { // 不分享
            let flag = false;  // 是否展开收缩
            let scope = record.scope;
            for (let key of showKeys) {
              if (key === record.id) {
                flag = true;
                break;
              }
            }
            if (!scope) { // 素材
              let updNode = null;
              let delNode = null;
              if (authCodes[buttonAuth[1]]) {
                updNode = <li title={window.language['common.update']} onClick={(e) => { self.onShowRename(e, record) }}><Icon className="edit-o" /></li>
              }
              if (authCodes[buttonAuth[2]]) {
                delNode = <li title={window.language['common.del']} onClick={(e) => { self.onDeleteFile(e, record) }}><Icon className="delete-o" /></li>
              }
              resultNode = (
                <div>
                  {flag ? (
                    <ul className='material-listoper-default'>
                      {updNode}
                      {delNode}
                      {shareNode}
                      <li title={window.language['material.preview']} onClick={(e) => { self.onShowPreviewHandler(e, record) }}><Icon className="preview-o" /></li>
                      {downNode}
                      <li onClick={(e) => { self.onListToolAction(e, record.id, false) }}><Icon className='left-arrow-o' /></li>
                    </ul>
                  ) : (
                      <ul className='material-listoper-default'>
                        {updNode}
                        {delNode}
                        {shareNode}
                        <li onClick={(e) => { self.onListToolAction(e, record.id, true) }}><Icon className='right-arrow-o' /> <span className="more">{window.language['common.more']}</span></li>
                      </ul>
                    )}
                </div>
              );
            } else {  // 文件夹
              let editNode = null;
              let delNode = null;
              if (authCodes[buttonAuth[5]]) {
                editNode = <li title={window.language['material.folder.editFolder']} onClick={(e) => { self.onShowAddFolder(e, '1', record) }}><Icon className="edit-o" /></li>
              }
              if (authCodes[buttonAuth[3]]) {
                delNode = <li title={window.language['common.del']} onClick={(e) => { self.onDeleteFile(e, record) }}><Icon className="delete-o" /></li>
              }
              resultNode = (
                <ul className='material-listoper-default'>
                  {editNode}
                  {delNode}
                </ul>
              );
            }
          }
          return (
            <div>
              {resultNode}
            </div>
          )
        }
      },
      formItem: {},
    }
  ]
};

export const columnsMusic = (self, showKeys, parentOrgIds, isShare, buttonAuth) => {
  return [
    {
      title: window.language['material.columns.filename'],
      name: 'name',
      dataIndex: 'name',
      tableItem: {
        width: 240,
        render(text, record) {
          let scope = record.scope;
          let folderIcon = null;
          if (scope) {
            folderIcon = <Icon className="material-folder-o" />;
          }else{
            text = `${text}.${record.suffix}`;
          }
          
          let nameContent = (<div className="material-column"
            onClick={(e) => {
              self.onCheckedMaterialData(record);
              self.onDoubleClickData(e, record);
            }}
          >
            {folderIcon}
            {textEllipsis(text, 22)}
          </div>);
          return nameContent;
        }
      },
      formItem: {}
    },
    {
      title: window.language['material.columns.size'],
      name: 'size',
      dataIndex: 'size',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['video.columns.time'],
      name: 'music_time',
      dataIndex: 'music_time',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['material.columns.org'],
      name: 'org.name',
      dataIndex: 'org.name',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['material.columns.creator'],
      name: 'creator.username',
      dataIndex: 'creator.username',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['material.columns.updateTime'],
      name: 'updateTime',
      dataIndex: 'updateTime',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['common.operate'],
      name: 'oper',
      dataIndex: 'oper',
      tableItem: {
        width: '23%',
        render(text, record) {
          let resultNode = null;
          let isShareStatus = record.is_share;
          const authCodes = $$.getStore('authCodes');//按钮权限代码列表
          if (!authCodes) return null;
          let shareParam = { tipMsg: '', iconMsg: '' };
          if (isShareStatus === '0') {
            shareParam.tipMsg = window.language['material.share'];
            shareParam.iconMsg = 'share-o';
          } else {
            shareParam.tipMsg = window.language['material.cancelShare'];
            shareParam.iconMsg = 'share-no-o';
          }
          let shareNode = null;
          let downNode = null;
          if (authCodes[buttonAuth[6]]) {
            shareNode = <li title={shareParam.tipMsg} onClick={(e) => { self.onShareFile(e, isShareStatus, record) }}><Icon className={shareParam.iconMsg} /></li>
          }
          if (authCodes[buttonAuth[9]]) {
            downNode = <li title={window.language['common.download']} onClick={(e) => { self.onDownloadMaterial(e, record) }}><Icon className="material-download-list" /></li>
          }
          if (isShare === '1') { // 我的分享/共享素材
            let operShare = shareNode;
            if (parentOrgIds && parentOrgIds.length > 0) {
              let arr = parentOrgIds.split(",");
              let index = arr.indexOf(record.org.id);
              if (index !== -1) {
                operShare = null;
              }
            }
            resultNode = (
              <ul className='material-listoper-default'>
                <li title={window.language['material.preview']} onClick={(e) => { self.onShowPreviewHandler(e, record) }}><Icon className="preview-o" /></li>
                {downNode}
                {operShare}
              </ul>
            );
          } else { // 不分享
            let flag = false;  // 是否展开收缩
            let scope = record.scope;
            for (let key of showKeys) {
              if (key === record.id) {
                flag = true;
                break;
              }
            }
            if (!scope) { // 素材
              let updNode = null;
              let delNode = null;
              if (authCodes[buttonAuth[1]]) {
                updNode = <li title={window.language['common.update']} onClick={(e) => { self.onShowRename(e, record) }}><Icon className="edit-o" /></li>
              }
              if (authCodes[buttonAuth[2]]) {
                delNode = <li title={window.language['common.del']} onClick={(e) => { self.onDeleteFile(e, record) }}><Icon className="delete-o" /></li>
              }
              resultNode = (
                <div>
                  {flag ? (
                    <ul className='material-listoper-default'>
                      {updNode}
                      {delNode}
                      {shareNode}
                      <li title={window.language['material.preview']} onClick={(e) => { self.onShowPreviewHandler(e, record) }}><Icon className="preview-o" /></li>
                      {downNode}
                      <li onClick={(e) => { self.onListToolAction(e, record.id, false) }}><Icon className='left-arrow-o' /></li>
                    </ul>
                  ) : (
                      <ul className='material-listoper-default'>
                        {updNode}
                        {delNode}
                        {shareNode}
                        <li onClick={(e) => { self.onListToolAction(e, record.id, true) }}><Icon className='right-arrow-o' /> <span className="more">{window.language['common.more']}</span></li>
                      </ul>
                    )}
                </div>
              );
            } else {  // 文件夹
              let editNode = null;
              let delNode = null;
              if (authCodes[buttonAuth[5]]) {
                editNode = <li title={window.language['material.folder.editFolder']} onClick={(e) => { self.onShowAddFolder(e, '1', record) }}><Icon className="edit-o" /></li>
              }
              if (authCodes[buttonAuth[3]]) {
                delNode = <li title={window.language['common.del']} onClick={(e) => { self.onDeleteFile(e, record) }}><Icon className="delete-o" /></li>
              }
              resultNode = (
                <ul className='material-listoper-default'>
                  {editNode}
                  {delNode}
                </ul>
              );
            }
          }
          return (
            <div>
              {resultNode}
            </div>
          )
        }
      },
      formItem: {},
    }
  ]
};

export const columnsOffice = (self, showKeys, parentOrgIds, isShare, buttonAuth) => {
  return [
    {
      title: window.language['material.columns.filename'],
      name: 'name',
      dataIndex: 'name',
      tableItem: {
        width: 240,
        render(text, record) {
          let divWH = { width: 250, height: 250 };
          let scope = record.scope;
          let returnNode = null;
          let previewList = record.previewList;
          let src = "";
          if (previewList && previewList.length > 0) {
            src = previewList[0].path;
          }

          let showImgContent = (null);

          if (record.status === '0') {//处理中
            showImgContent = (
              <div style={{ width: divWH.width + 'px', height: divWH.height + 'px', backgroundColor: '#f5f5f5' }}>
                <Img src={"assets/images/material/material-convert.gif"} style={{ width: '32px', height: '32px', margin: 'auto', position: 'absolute', top: 0, left: 0, bottom: 0, right: 0}} />
              </div>
            );
          } else if (record.status === '1') {//处理成功
            showImgContent = (
              <div style={{ width: divWH.width + 'px', height: divWH.height + 'px', backgroundColor: '#000000' }}>
                <Img src={record.preview} style={{ width: divWH.width + 'px', height: divWH.height + 'px' }} />
              </div>
            );
          } else if (record.status === '2') {//处理失败
            showImgContent = (
              <div style={{ width: divWH.width + 'px', height: divWH.height + 'px', backgroundColor: '#000000', color: '#ffffff', textAlign: 'center', opacity: 0.7 }}>
                <Img src={"assets/images/material/material-fail.png"} style={{ width: '80px', height: '80px', margin: 'auto', position: 'absolute', top: 0, left: 0, bottom: 0, right: 0}} />
                <div style={{ textAlign: 'center'}}>{window.language['material.upload.failMsg']}</div>
              </div>
            );
          }

          let folderIcon = null;
          if (scope) {
            folderIcon = <Icon className="material-folder-o" />;
          }else{
            text = `${text}.${record.suffix}`;
          }
          
          let nameContent = (<div className="material-column"
            onClick={(e) => {
              self.onCheckedMaterialData(record);
              self.onDoubleClickData(e, record);
            }}
          >
            {folderIcon}
            {textEllipsis(text, 22)}
          </div>);
          if (scope) {
            return nameContent;
          }else {
            return (<Popover placement="right" content={showImgContent} title={text}>
              {nameContent}
            </Popover>)
          }
        }
      },
      formItem: {}
    },
    {
      title: window.language['material.columns.size'],
      name: 'size',
      dataIndex: 'size',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['video.columns.pagetime'],
      name: 'interval_time',
      dataIndex: 'interval_time',
      tableItem: {},
    },
    {
      title: window.language['video.columns.time'],
      name: 'playtime',
      dataIndex: 'playtime',
      tableItem: {},
    },
    {
      title: window.language['video.columns.status'],
      name: 'status',
      dataIndex: 'status',
      dict: [{
        code: '1',
        codeName: window.language['video.status.normal']
      },
      {
        code: '0',
        codeName: window.language['video.status.processing']
      },
      {
        code: '2',
        codeName: window.language['video.status.processFailed']
      }],
      tableItem: {},
    },
    {
      title: window.language['material.columns.org'],
      name: 'org.name',
      dataIndex: 'org.name',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['material.columns.creator'],
      name: 'creator.username',
      dataIndex: 'creator.username',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['material.columns.updateTime'],
      name: 'updateTime',
      dataIndex: 'updateTime',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['common.operate'],
      name: 'oper',
      dataIndex: 'oper',
      tableItem: {
        width: '23%',
        render(text, record, index) {
          let resultNode = null;
          let isShareStatus = record.is_share;
          const authCodes = $$.getStore('authCodes');//按钮权限代码列表
          if (!authCodes) return null;
          let shareParam = { tipMsg: '', iconMsg: '' };
          if (isShareStatus === '0') {
            shareParam.tipMsg = window.language['material.share'];
            shareParam.iconMsg = 'share-o';
          } else {
            shareParam.tipMsg = window.language['material.cancelShare'];
            shareParam.iconMsg = 'share-no-o';
          }
          let shareNode = null;
          let downNode = null;
          if (authCodes[buttonAuth[6]]) {
            shareNode = <li title={shareParam.tipMsg} onClick={(e) => { self.onShareFile(e, isShareStatus, record) }}><Icon className={shareParam.iconMsg} /></li>
          }
          if (authCodes[buttonAuth[9]]) {
            downNode = <li title={window.language['common.download']} onClick={(e) => { self.onDownloadMaterial(e, record) }}><Icon className="material-download-list" /></li>
          }
          if (isShare === '1') { // 我的分享/共享素材
            let operShare = shareNode;
            if (parentOrgIds && parentOrgIds.length > 0) {
              let arr = parentOrgIds.split(",");
              let index = arr.indexOf(record.org.id);
              if (index !== -1) {
                operShare = null;
              }
            }
            resultNode = (
              <ul className='material-listoper-default'>
                <li title={window.language['material.preview']} onClick={(e) => { self.onShowPreviewHandler(e, record) }}><Icon className="preview-o" /></li>
                {downNode}
                {operShare}
              </ul>
            );
          } else { // 不分享
            let flag = false;  // 是否展开收缩
            let scope = record.scope;
            for (let key of showKeys) {
              if (key === record.id) {
                flag = true;
                break;
              }
            }
            if (!scope) { // 素材
              let updNode = null;
              let delNode = null;
              if (authCodes[buttonAuth[1]]) {
                updNode = <li title={window.language['common.update']} onClick={(e) => { self.onShowRename(e, record) }}><Icon className="edit-o" /></li>
              }
              if (authCodes[buttonAuth[2]]) {
                delNode = <li title={window.language['common.del']} onClick={(e) => { self.onDeleteFile(e, record) }}><Icon className="delete-o" /></li>
              }
              resultNode = (
                <div>
                  {flag ? (
                    <ul className='material-listoper-default'>
                      {updNode}
                      {delNode}
                      {shareNode}
                      <li title={window.language['material.preview']} onClick={(e) => { self.onShowPreviewHandler(e, record) }}><Icon className="preview-o" /></li>
                      {downNode}
                      <li onClick={(e) => { self.onListToolAction(e, record.id, false) }}><Icon className='left-arrow-o' /></li>
                    </ul>
                  ) : (
                      <ul className='material-listoper-default'>
                        {updNode}
                        {delNode}
                        {shareNode}
                        <li onClick={(e) => { self.onListToolAction(e, record.id, true) }}><Icon className='right-arrow-o' /> <span className="more">{window.language['common.more']}</span></li>
                      </ul>
                    )}
                </div>
              );
            } else {  // 文件夹
              let editNode = null;
              let delNode = null;
              if (authCodes[buttonAuth[5]]) {
                editNode = <li title={window.language['material.folder.editFolder']} onClick={(e) => { self.onShowAddFolder(e, '1', record) }}><Icon className="edit-o" /></li>
              }
              if (authCodes[buttonAuth[3]]) {
                delNode = <li title={window.language['common.del']} onClick={(e) => { self.onDeleteFile(e, record) }}><Icon className="delete-o" /></li>
              }
              resultNode = (
                <ul className='material-listoper-default'>
                  {editNode}
                  {delNode}
                </ul>
              );
            }
          }
          return (
            <div>
              {resultNode}
            </div>
          )
        }
      },
      formItem: {},
    }
  ]
};

export const columnsLive = (self, parentOrgIds, isShare, buttonAuth) => {
  return [
    {
      title: window.language['material.columns.filename'],
      name: 'name',
      dataIndex: 'name',
      tableItem: {
        width: 240,
        render(text, record) {
          let scope = record.scope;
          return (
            <div title={text} className={`${scope ? 'material-column' : null}`}
              onClick={(e) => {
                self.onCheckedMaterialData(record);
                self.onDoubleClickData(e, record);
              }}
            >
              {record.scope ? <Icon className="material-folder-o" /> : null}
              {textEllipsis(text, 22)}
            </div>
          )
        }
      },
      formItem: {}
    },
    {
      title: window.language['material.columns.url'],
      name: 'url',
      dataIndex: 'url',
      tableItem: {
        width: 250,
        render(text) {
          return (
            <div title={text} style={{ width: '250px' }} className="text-ellipsis">
              {text}
            </div>
          )
        }
      },
      formItem: {},
    },
    {
      title: window.language['material.columns.org'],
      name: 'org.name',
      dataIndex: 'org.name',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['material.columns.addCreator'],
      name: 'updater.username',
      dataIndex: 'updater.username',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['material.columns.updateTime'],
      name: 'updateTime',
      dataIndex: 'updateTime',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['common.operate'],
      name: 'oper',
      dataIndex: 'oper',
      tableItem: {
        width: '23%',
        render(text, record) {
          let resultNode = null;
          let isShareStatus = record.is_share;
          const authCodes = $$.getStore('authCodes');//按钮权限代码列表
          if (!authCodes) return null;
          let shareParam = { tipMsg: '', iconMsg: '' };
          if (isShareStatus === '0') {
            shareParam.tipMsg = window.language['material.share'];
            shareParam.iconMsg = 'share-o';
          } else {
            shareParam.tipMsg = window.language['material.cancelShare'];
            shareParam.iconMsg = 'share-no-o';
          }
          let shareNode = null;
          if (authCodes[buttonAuth[6]]) {
            shareNode = <li title={shareParam.tipMsg} onClick={(e) => { self.onShareFile(e, isShareStatus, record) }}><Icon className={shareParam.iconMsg} /></li>
          }
          if (isShare === '1') { // 分享
            let operShare = shareNode;
            if (parentOrgIds && parentOrgIds.length > 0) {
              let arr = parentOrgIds.split(",");
              let index = arr.indexOf(record.org.id);
              if (index !== -1) {
                operShare = null;
              }
            }
            resultNode = (
              <ul className='material-listoper-default'>
                <li title={window.language['material.preview']} onClick={(e) => { self.onShowAddLive(e, '2', record) }}><Icon className="preview-o" /></li>
                {operShare}
              </ul>
            );
          } else { // 不分享
            let scope = record.scope;
            if (!scope) { // 素材
              resultNode = (
                <div>
                  <ul className='material-listoper-default'>
                    {authCodes[buttonAuth[1]] ? (
                      <li title={window.language['common.update']} onClick={(e) => { self.onShowAddLive(e, '1', record) }}><Icon className="edit-o" /></li>
                    ) : null}
                    {authCodes[buttonAuth[2]] ? (
                      <li title={window.language['common.del']} onClick={(e) => { self.onDeleteFile(e, record) }}><Icon className="delete-o" /></li>
                    ) : null}
                    {shareNode}
                  </ul>
                </div>
              );
            } else {  // 文件夹
              resultNode = (
                <ul className='material-listoper-default'>
                  {authCodes[buttonAuth[5]] ? (
                    <li title={window.language['material.folder.editFolder']} onClick={(e) => { self.onShowAddFolder(e, '1', record) }}><Icon className="edit-o" /></li>
                  ) : null}
                  {authCodes[buttonAuth[3]] ? (
                    <li title={window.language['common.del']} onClick={(e) => { self.onDeleteFile(e, record) }}><Icon className="delete-o" /></li>
                  ) : null}
                </ul>
              );
            }
          }
          return (
            <div>
              {resultNode}
            </div>
          )
        }
      },
      formItem: {},
    }
  ]
};

export const columnsDynamicText = (self, parentOrgIds, isShare, buttonAuth) => {
  return [
    {
      title: window.language['material.columns.filename'],
      name: 'name',
      dataIndex: 'name',
      tableItem: {
        width: 240,
        render(text, record) {
          let scope = record.scope;
          return (
            <div title={text} className={`${scope ? 'material-column' : null}`}
              onClick={(e) => {
                self.onCheckedMaterialData(record);
                self.onDoubleClickData(e, record);
              }}
            >
              {record.scope ? <Icon className="material-folder-o" /> : null}
              {textEllipsis(text, 22)}
            </div>
          )
        }
      },
      formItem: {}
    },
    {
      title: window.language['material.columns.url'],
      name: 'url',
      dataIndex: 'url',
      tableItem: {
        width: 250,
        render(text) {
          return (
            <div title={text} style={{ width: '250px' }} className="text-ellipsis">
              {text}
            </div>
          )
        }
      },
      formItem: {},
    },
    {
      title: window.language['material.columns.org'],
      name: 'org.name',
      dataIndex: 'org.name',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['material.columns.addCreator'],
      name: 'creator.username',
      dataIndex: 'creator.username',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['material.columns.updateTime'],
      name: 'updateTime',
      dataIndex: 'updateTime',
      tableItem: {},
      formItem: {},
    },
    {
      title: window.language['common.operate'],
      name: 'oper',
      dataIndex: 'oper',
      tableItem: {
        width: '23%',
        render(text, record) {
          let resultNode = null;
          let isShareStatus = record.is_share;
          const authCodes = $$.getStore('authCodes');//按钮权限代码列表
          if (!authCodes) return null;
          let shareParam = { tipMsg: '', iconMsg: '' };
          if (isShareStatus === '0') {
            shareParam.tipMsg = window.language['material.share'];
            shareParam.iconMsg = 'share-o';
          } else {
            shareParam.tipMsg = window.language['material.cancelShare'];
            shareParam.iconMsg = 'share-no-o';
          }
          let shareNode = null;
          if (authCodes[buttonAuth[6]]) {
            shareNode = <li title={shareParam.tipMsg} onClick={(e) => { self.onShareFile(e, isShareStatus, record) }}><Icon className={shareParam.iconMsg} /></li>
          }
          if (isShare === '1') { // 分享
            let operShare = shareNode;
            if (parentOrgIds && parentOrgIds.length > 0) {
              let arr = parentOrgIds.split(",");
              let index = arr.indexOf(record.org.id);
              if (index !== -1) {
                operShare = null;
              }
            }
            resultNode = (
              <ul className='material-listoper-default'>
                <li title={window.language['material.preview']} onClick={(e) => { self.onShowRss(e, '2', record) }}><Icon className="preview-o" /></li>
                {operShare}
              </ul>
            );
          } else { // 不分享
            let scope = record.scope;
            if (!scope) { // 素材
              resultNode = (
                <div>
                  <ul className='material-listoper-default'>
                    {authCodes[buttonAuth[1]] ? (
                      <li title={window.language['common.update']} onClick={(e) => { self.onShowRss(e, '1', record) }}><Icon className="edit-o" /></li>
                    ) : null}
                    {authCodes[buttonAuth[2]] ? (
                      <li title={window.language['common.del']} onClick={(e) => { self.onDeleteFile(e, record) }}><Icon className="delete-o" /></li>
                    ) : null}
                    {shareNode}
                  </ul>
                </div>
              );
            } else {  // 文件夹
              resultNode = (
                <ul className='material-listoper-default'>
                  {authCodes[buttonAuth[5]] ? (
                    <li title={window.language['material.folder.editFolder']} onClick={(e) => { self.onShowAddFolder(e, '1', record) }}><Icon className="edit-o" /></li>
                  ) : null}
                  {authCodes[buttonAuth[3]] ? (
                    <li title={window.language['common.del']} onClick={(e) => { self.onDeleteFile(e, record) }}><Icon className="delete-o" /></li>
                  ) : null}
                </ul>
              );
            }
          }
          return (
            <div>
              {resultNode}
            </div>
          )
        }
      },
      formItem: {},
    }
  ]
};


// WEBPACK FOOTER //
// ./src/routes/Material/Util/components/columns.js